/**
 * Toggle the mobile filter panel for showing facets
 */
export function toggle_mobile_filter() {
	const toggle = document.querySelector( '.category-filter-toggle' )
	const close  = document.querySelector( '.post-filter-close-btn' )
	const panel  = document.querySelector( '.post-filter-sidebar' )

	if ( ! toggle) return ;

		toggle.addEventListener(
			"click",
			() => {
            panel.classList.toggle( "enabled" )
			}
		)

		close.addEventListener(
			'click',
			() => {
            if (panel.classList.contains( 'enabled' )) {
                panel.classList.remove( 'enabled' )
            }
			}
		)

		document.addEventListener(
			'click',
			(event) => {
            const isClickInside   = panel.contains( event.target )
				const isClickOnButton = toggle.contains( event.target )

				if ( ! isClickInside && ! isClickOnButton && panel.classList.contains( 'enabled' )) {
					panel.classList.remove( 'enabled' )
				}
			}
		)
}

export function articles_section_case_study() {
	const case_study_grid = document.querySelector( '.case-study-articles-section-grid' );
	if(case_study_grid) {
		const articles_blocks = document.querySelectorAll('.ig-dedicated-blog-group.articles-section');
	
		if(articles_blocks.length > 0) {
			articles_blocks.forEach(block => {
				const parent = block.closest('.case-study-articles-section-grid');
				
				if (!parent) {
					block.remove(); 
				}
			});
		}
	}
}